interface WaveDividerProps {
  fromColor?: string;
  toColor?: string;
  height?: number;
  className?: string;
}

/** Wave-shaped section divider — softer, more organic transition */
export function WaveDivider({
  fromColor = '#f9fafb',
  toColor = '#ffffff',
  height = 80,
  className = '',
}: WaveDividerProps) {
  return (
    <div
      className={`relative w-full overflow-hidden ${className}`}
      style={{ height: `${height}px`, background: fromColor }}
    >
      <svg
        className="absolute inset-0 w-full h-full"
        preserveAspectRatio="none"
        viewBox={`0 0 1440 ${height}`}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d={`M0,${height} L0,0 Q360,${height} 720,${height * 0.3} Q1080,${-height * 0.3} 1440,${height * 0.2} L1440,${height} Z`}
          style={{ fill: toColor }}
        />
      </svg>
    </div>
  );
}

interface CurvedDividerProps {
  fromColor?: string;
  toColor?: string;
  height?: number;
  className?: string;
}

/** Curved divider — elegant smooth curve between sections */
export function CurvedDivider({
  fromColor = '#f9fafb',
  toColor = '#ffffff',
  height = 80,
  className = '',
}: CurvedDividerProps) {
  return (
    <div
      className={`relative w-full overflow-hidden ${className}`}
      style={{ height: `${height}px`, background: fromColor }}
    >
      <svg
        className="absolute inset-0 w-full h-full"
        preserveAspectRatio="none"
        viewBox={`0 0 1440 ${height}`}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d={`M0,0 Q720,${height * 1.5} 1440,0 L1440,${height} L0,${height} Z`}
          style={{ fill: toColor }}
        />
      </svg>
    </div>
  );
}